module.exports = __webpack_public_path__ + "img/footer_notification--disabled.091c5561.svg";